var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 76,
    viewBox: "0 0 45 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2058)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18178 0.160156L3.20593 12.971L0 51.8141L0.641186 63.9838L1.70555 71.242L8.74578 75.0891L44.6009 43.2863C44.6009 43.2863 24.3266 14.8818 23.9034 14.0354C23.4802 13.1762 9.16896 0.160156 9.16896 0.160156H9.18178Z",
    fill: "url(#paint0_linear_1_2058)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0494 43.2477L36.291 41.1318L34.8291 44.5814L40.9845 46.4921L44.4854 43.3888L44.0494 43.2477Z",
    fill: "url(#paint1_linear_1_2058)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M24.2495 22.4348C24.2495 22.4348 29.7252 25.038 32.213 25.8844C27.9043 19.8188 24.0828 14.4072 23.9033 14.0481C23.4801 13.1889 9.18164 0.172852 9.18164 0.172852L11.5797 7.86708L24.2623 22.4348H24.2495Z",
    fill: "url(#paint2_linear_1_2058)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8649 18.5367L24.2503 22.4351C24.2503 22.4351 29.726 25.0384 32.2138 25.8847C27.9051 19.8191 24.0836 14.4075 23.9041 14.0484C23.7374 13.715 21.4163 11.4837 18.6592 8.91895C19.3517 12.0736 20.416 16.6516 20.852 18.5624L20.8649 18.5367Z",
    fill: "url(#paint3_linear_1_2058)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.31
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3769 57.4301L8.86119 66.9453L7.11716 60.4822C7.11716 60.4822 7.64293 56.494 7.64293 56.1221C7.64293 55.7502 9.63061 24.3578 9.63061 24.3578L3.74453 13.4961L3.14181 13.6372L0 51.8134L0.641186 63.9831L1.70555 71.2413L8.74578 75.0884L34.9703 51.839L20.3769 57.4558V57.4301Z",
    fill: "#0043C9"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M7.13012 60.4828C7.13012 60.4828 7.65589 56.4946 7.65589 56.1227C7.65589 56.0073 7.8226 53.2117 8.06625 49.3133C7.20706 47.5308 3.5523 37.4514 1.61592 32.0654L-0.0126953 51.814L0.628491 63.9837L7.11729 60.4828H7.13012Z",
    fill: "url(#paint4_linear_1_2058)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.42
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98908 66.3819C7.70696 66.2921 3.85985 69.2672 1.66699 70.9984L1.70546 71.2421L8.74568 75.0892L8.8611 66.9589L7.97626 66.3947L7.98908 66.3819Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.42
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5668 9.31641C11.5668 9.31641 9.09184 24.256 8.87384 24.692C8.65583 25.128 8.01465 61.9962 8.01465 61.9962L8.87384 66.9462L34.7906 45.2228C34.7906 45.2228 37.0475 41.5681 36.945 41.132C36.8424 40.696 24.2623 22.4222 24.2623 22.4222L11.5668 9.31641Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18224 1.17344L10.7083 9.32932L8.92577 23.1148C8.92577 23.1148 3.75781 13.2406 3.75781 13.5099C3.75781 13.7792 8.8873 24.705 8.8873 24.705L8.36153 44.9664C8.36153 44.9664 9.66955 25.7052 9.66955 24.3844C9.66955 23.0635 11.9906 10.1372 11.9906 10.1372C11.9906 10.1372 24.7887 23.3969 24.9811 23.5252C25.1734 23.6534 32.2008 25.718 32.2008 25.718L24.84 22.4095L11.5675 7.8546C11.5675 7.8546 9.18224 0.968261 9.18224 1.17344Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6613 30.3213L37.3427 40.529L44.0495 43.2476L37.5479 41.9268L35.9578 44.7095L40.6 46.2996L34.7652 45.9021L20.377 57.4306L34.8293 44.5813L36.2912 41.1317L29.6613 30.3213Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23301 49.5822L8.01501 61.9955C8.01501 61.9955 8.8229 66.907 8.87419 66.9455C8.92549 66.9839 8.78443 74.3319 8.78443 74.3319L7.98936 66.3812L2.15457 70.8182L7.65594 65.4451L7.13017 60.4695L0.37207 51.8648L7.25841 59.4821L8.23301 49.5693V49.5822Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.10449 56.7385C12.7339 48.121 24.9549 24.769 25.455 25.0126C25.5704 25.0639 25.8653 25.1922 26.2629 25.3589C25.0574 23.602 24.2496 22.4222 24.2496 22.4222L22.326 20.4346L21.7617 20.691C21.1334 21.3194 11.7721 34.8356 8.43791 39.6573C8.30967 45.7101 8.18143 52.2887 8.10449 56.7257V56.7385Z",
    fill: "url(#paint5_linear_1_2058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4296 53.0578C27.507 48.9927 31.0977 41.555 33.6624 36.1947C32.7006 34.7712 31.6106 33.1683 30.5206 31.5781C30.4821 31.6551 30.4308 31.732 30.3924 31.7961C29.9179 32.6297 17.5815 54.3017 12.2725 64.0862L25.4296 53.0578Z",
    fill: "url(#paint6_linear_1_2058)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4375 42.6709L8.23332 49.5829L13.2987 53.0966L8.60521 47.5311L4.4375 42.6709Z",
    fill: "url(#paint7_linear_1_2058)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M4.4375 42.6709L8.23332 49.5829L13.2987 53.0966L8.60521 47.5311L4.4375 42.6709Z",
    fill: "#031847"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09082 43.9922L8.23263 49.5833L13.298 53.097L8.07875 50.7118L5.09082 43.9922Z",
    fill: "url(#paint8_linear_1_2058)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2058",
    x1: 23.0699,
    y1: 71.8191,
    x2: 20.0948,
    y2: -23.1662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2058",
    x1: 43.4979,
    y1: 27.3079,
    x2: 38.5864,
    y2: 48.6209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2058",
    x1: 17.9146,
    y1: 20.7036,
    x2: 23.4801,
    y2: 5.34081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2058",
    x1: 23.5963,
    y1: 5.14877,
    x2: 28.4821,
    y2: 37.5799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2058",
    x1: -0.063991,
    y1: 27.295,
    x2: 8.09189,
    y2: 81.4624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2058",
    x1: 4.91139,
    y1: 66.8692,
    x2: 31.8797,
    y2: -7.58525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2058",
    x1: 15.5297,
    y1: 70.7033,
    x2: 42.4851,
    y2: -3.75121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2058",
    x1: 6.9766,
    y1: 52.8914,
    x2: 11.5034,
    y2: 40.9012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2058",
    x1: 5.09082,
    y1: 48.5446,
    x2: 13.298,
    y2: 48.5446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.6137,
    height: 74.9161,
    fill: "white",
    transform: "translate(0 0.160156)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/next-button.svg";
export { ForwardRef as ReactComponent };